import { apiFetch } from "../../api";
import { BASE_URL as u } from "../../../commonUrls";

const BASE = `${u}/paper-trading`;

export const getPortfolios = () =>
  apiFetch(`${BASE}/portfolios`).then(r => r.json());

export const getSummary = (portfolioId) =>
  apiFetch(`${BASE}/portfolios/${portfolioId}/summary`).then(r => r.json());

export const createPortfolio = (data) =>
  apiFetch(`${BASE}/portfolios`, { method: "POST",
    headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) }).then(r => r.json());

export const updatePortfolio = (portfolioId, data) =>
  apiFetch(`${BASE}/portfolios/${portfolioId}`, { method: "PUT",
    headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) }).then(r => r.json());

export const deletePortfolio = (portfolioId) =>
  apiFetch(`${BASE}/portfolios/${portfolioId}`, { method: "DELETE" });

export const getTrades = (portfolioId) =>
  apiFetch(`${BASE}/portfolios/${portfolioId}/trades`).then(r => r.json());

export const executeTrade = (portfolioId, data) =>
  apiFetch(`${BASE}/portfolios/${portfolioId}/trades`, { method: "POST",
    headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) }).then(r => r.json());

export const deleteTrade = (portfolioId, tradeId) =>
  apiFetch(`${BASE}/portfolios/${portfolioId}/trades/${tradeId}`, { method: "DELETE" });
